import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { AsyncEntity } from '../../global';
import createAsyncThunkFromFetch from '../../store/middlewares/createAsyncThunkFromFetch';
import {
  createAccount as createAccountAPI,
  deleteAccount as deleteAccountAPI,
  getAccounts,
  updateAccount as updateAccountAPI,
} from './accounts.api';
import { Account } from './accounts.types';

const name = 'accounts';

const accountEntityAdapter = createEntityAdapter<AsyncEntity<Account>>({
  selectId: account => account.id,
});

export const accountsSelectors = accountEntityAdapter.getSelectors();

export const fetchAccounts = createAsyncThunkFromFetch(`${name}/fetchAccounts`, getAccounts);
export const deleteAccount = createAsyncThunkFromFetch(`${name}/deleteAccount`, deleteAccountAPI);
export const createAccount = createAsyncThunkFromFetch(`${name}/createAccount`, createAccountAPI);
export const updateAccount = createAsyncThunkFromFetch(`${name}/updateAccount`, updateAccountAPI);

const accountsSlice = createSlice({
  name,
  initialState: accountEntityAdapter.getInitialState({
    isPending: false,
    hasError: false,
  }),
  reducers: {},
  extraReducers: builder => {
    // Accounts
    builder.addCase(fetchAccounts.pending, state => {
      state.isPending = true;
      state.hasError = false;
    });
    builder.addCase(fetchAccounts.fulfilled, (state, { payload }) => {
      accountEntityAdapter.upsertMany(state, payload);
      state.isPending = false;
      state.hasError = false;
    });
    builder.addCase(fetchAccounts.rejected, state => {
      state.isPending = false;
      state.hasError = true;
    });
    builder.addCase(deleteAccount.pending, (state, { meta }) => {
      accountEntityAdapter.updateOne(state, {
        id: meta.arg.id,
        changes: { isPending: true },
      });
    });
    builder.addCase(deleteAccount.fulfilled, (state, { meta }) => {
      accountEntityAdapter.removeOne(state, meta.arg.id);
    });
    builder.addCase(deleteAccount.rejected, (state, { meta }) => {
      accountEntityAdapter.updateOne(state, {
        id: meta.arg.id,
        changes: { isPending: false, hasError: true },
      });
    });
    builder.addCase(createAccount.fulfilled, (state, { payload }) => {
      accountEntityAdapter.upsertOne(state, payload);
    });
  },
});

const { reducer } = accountsSlice;

export default reducer;
